exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63910f36","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/Home.vue
// module id = 70
// module chunks = 0